import { Navigate, Outlet } from "react-router-dom"
import { getValidToken } from "@/lib/auth-token"

/** Public pages (login). Signed-in users are sent straight to the dashboard. */
export function AuthLayout() {
  if (getValidToken()) return <Navigate to="/dashboard" replace />
  return <Outlet />
}
